module.exports = __webpack_public_path__ + "img/mi-menu_open.a3f4ff44.svg";